import React from 'react'
import Navbar from './UI Components/Navbar'
import HeroSec from './UI Components/HeroSec'
import Timeline from './UI Components/Timeline'
import Footer from './UI Components/Footer'
import Docs from './Docs'

export default function Home() {
  return (
    <div className='flex flex-col'>
        <Navbar/>
        <HeroSec/>
        <Timeline/>
        <Docs/>
        <Footer/>
    </div>
  )
}
